export default "__VITE_ASSET__BAF5d6vf__"